<template>
    <div class="generalframezz">
        <div class="generalcontent" :style="{width:mywidth+'px',height:myheight+'px'}">
            <div :style="{height:myTitleheight+'px',lineHeight:myTitleheight+'px'}" class="general_title">
                <div class="general_title_left">
                    <div>版权家预存权益充值</div>
                </div>
                <img @click="parentHandleclick()" class="timgclose" src="./images/ty_close.png" />
            </div>
            <div class="topManb">
                <div v-for="(item,index) in vipTypeArr" :key="index" class="vip_cont_subpay" :style="{backgroundImage: 'url('+item.bg+')',backgroundSize: '100% 100%'}">
                    <img :src="item.log" />
                    <div>
                        <p>￥{{item.amount}}</p>
                        <p>{{item.desc}}</p>
                    </div>
                    <input type="button" @click="goSy(item)" value="充值"/>
                </div>
            </div>
            <p class="red-p" v-if="showMoney">{{moneyTip}}</p>           
            <div class="recharge-code" v-if="showCode">
                <div><img src="./images/wc.png" class="position-img" style="top:22px;left:20px;" /></div>
                <div><img src="./images/zfb.png" class="position-img" style="top:21px;left:204px;height:20px;" /></div>
                <div><img src="./images/wallet.png" class="position-img" style="top:21px;left:388px;height:20px;" /></div>
                <div><img src="./images/redBao.png" class="position-img" style="top:16px;left:572px;height:25px;width:25px;" /></div>
                <Tabs ref="testRef" type="card" active-key="key1" @on-click="changeTabs">
                    <Tab-pane label="微信支付" key="key1">                        
                        <img :src="wxCode" class="card-code" v-if="wxCode && wxCode"/>
                    </Tab-pane>
                    <Tab-pane label="支付宝支付" key="key2">
                        <img :src="zfbCode" class="card-code" v-if="zfbCode && zfbCode" />
                    </Tab-pane>
                    <Tab-pane label="我的余额支付" key="key3">
                        <div class="yezfback">
                            <p class="hbyeplw">当前余额：{{amount}}</p>
                            <p class="hbyeplx">本次需支付：{{payMoney}}</p>
                             <p class="hbyeply" v-if="yenoMoney">余额不足，请充值</p>
                            <!-- <p class="hbyeply" v-if="amount < payMoney">余额不足，请充值</p> -->
                            <!-- <p class="hbyeply" v-if="yenoMoney">余额不足，请充值</p> -->
                            <input @click="yezfCodePay()" id="yueButton" class="hbyepbutton" type="button" value="确定" />
                        </div>
                    </Tab-pane>
                    <Tab-pane label="红包支付" key="key4">
                        <div class="hbzfback">
                            <!-- <p class="hbyeplw">{{hbnoMoney?'当前余额  ':'剩余余额  '}}{{hbamount}}</p>
                            <p class="hbyeplx">{{hbnoMoney?'当前需支付  ':'已支付  '}}{{payMoney}}</p> -->
                            <p class="hbyeplw">当前余额：{{hbamount}}</p>
                            <p class="hbyeplx">本次需支付：{{payMoney}}</p>
                            <p class="hbyeply" v-if="hbnoMoney">红包余额不足，请充值</p>
                            <!-- <p class="hbyeply" v-if="hbamount< payMoney">红包余额不足，请充值</p> -->
                             <input @click="hbzfCodePay()" id="redButton" class="hbyepbutton" type="button" value="确定" />
                        </div>
                    </Tab-pane>
                </Tabs>               
            </div> 
            <div class="recharge-code" v-if="showCode">
                <span style="margin-left:-84px;">产品自支付完成之时起5分钟内生效</span>
            </div>         
        </div>
    </div>
</template>

<script>
    import { userInfo } from "@/api/index";
    import {postMemberApplication,goPersonOrEnterVip,preRechargeMoney} from '@/api/staticPage'
    import { _findOne,_saveMoney,_getFindOne } from "@/api/wallet.js";
    import {getPrecharg} from '@/api/staticPage';
    import Cookies from "js-cookie";
    import $ from 'jquery';
    export default {
        name:'vipTypeGoOn',
        props:{
            mywidth:{
                type:String,
                default:'838'
            },
            myheight:{
                type:String,
                default:'495'
            },
            myTitleheight:{
                type:String,
                default:'50'
            },
            tishihide:{
                type:Boolean,
                default:true
            },
            routerLink:{
                type:String,
                default:''
            },
        },
        data(){
            return{
                money:"",
                moneyTip:"请输入提现金额",
                showMoney:false,
                wxCode:"",
                wxId:"",
                zfbCode:"",
                zfbId:"",
                showCode:!1,
                pandShow:0,
                hbamount:0,
                amount:0,
                yenoMoney:!1,
                hbnoMoney:!1,
                showKtList:[],
                showTypePerson:'',
                payMoney:0,
                subBizType:'',
                vipTypeArr:[],
                dengjiType:null,
            }
        },
        created(){
            let userInfos = Cookies.get("userInfo")?JSON.parse(Cookies.get("userInfo")):'';
            this.showTypePerson = userInfos && userInfos.accountType?userInfos.accountType:''
            this.findOne();
            this.getFindOne();
            this._getPrecharg()
        },
        methods:{
            _getPrecharg(){
                getPrecharg().then(res => {
					if(res.code==200){
            let newVipTypeArr = [];
						for(let i in res.result.gradeList){
							if(res.result.gradeList[i].code == 0){
								res.result.gradeList[i].bg = require("../../user/personal/images/hjbj.png");
								res.result.gradeList[i].log = require("../../user/personal/images/hjLog.png")
							}
							if(res.result.gradeList[i].code == 1){
								res.result.gradeList[i].bg = require("../../user/personal/images/zsBj.png");
								res.result.gradeList[i].log = require("../../user/personal/images/zsLog.png")
                newVipTypeArr.push(res.result.gradeList[i])
							}
							if(res.result.gradeList[i].code == 2){
								res.result.gradeList[i].bg = require("../../user/personal/images/bjBj.png");
								res.result.gradeList[i].log = require("../../user/personal/images/bjLog.png")
                newVipTypeArr.push(res.result.gradeList[i])
							}
						}
						this.vipTypeArr = res.result.gradeList;
            this.vipTypeArr = newVipTypeArr;
					}else{
						toast(res.message)
					}
				}); 
            },
            parentHandleclick() {
                clearInterval(this.clearTimer);
                this.$emit('fatherModal',false);
            },
            goSy(money){
                console.log(money)
                let _this = this;
                _this.dengjiType = money.code;
                let userInfos = Cookies.get("userInfo")?JSON.parse(Cookies.get("userInfo")):'';
                if(userInfos==''){
                    toast('请登录后再充值')
                    return false;
                }
                if(userInfos.realNameStatus != 'complete_real_name'){
                    toast('请实名认证后再充值')
                    return false;
                }
                this.showCode = !0
                this.subBizType = money.code
                this.payMoney = money.amount
                this.hbnoMoney=!1
                this.yenoMoney=!1
                this.wxCodePay()
            },
            //生成二维码
            wxCodePay(){
                let _this = this;
                const data={
                    payWay:'WechatPay',
                    grade:_this.dengjiType,
                }
                preRechargeMoney(data).then(res => {
                    if(res.code==200){
                        console.log(res)
                        this.wxCode = res.result.qr;
                        this.wxId=res.result.id;
                        this.clearTimer = this.clearTimer || setInterval(this.getPayStatus, 2000);                        
                    }                                           
                });
            },
            zfbCodePay(){
                let _this = this;
                const val={
                    grade:_this.dengjiType,
                    payWay:'AliPay',
                }
                preRechargeMoney(val).then(res => {
                    if(res.code==200){
                        this.zfbCode = res.result.qr;
                        this.zfbId=res.result.id;
                        this.clearTimer = this.clearTimer || setInterval(this.getPayStatus, 2000);
                    }                                           
                });
            },
            yezfCodePay(){
                 $("#yueButton").attr("disabled","disabled");
                 let _this = this;
                let userInfos = Cookies.get("userInfo")?JSON.parse(Cookies.get("userInfo")):'';
                const val={
                    grade:_this.dengjiType,
                    payWay:'Ewallet',
                }
                preRechargeMoney(val).then(res => {
                    if(res.code==200){
                        console.log('获取的余额的值',res)
                        toast("支付成功");   
                        if(_this.routerLink == 'go'){
                            _this.$router.push({
                                path: "/walletPackage"
                            });  
                        }                    
                        userInfo().then(res=>{
                            if (res.code==200) {
                                Cookies.set("userInfo", JSON.stringify(res.result));
                                _this.setStore("userInfo", res.result);
                                // let vipData=res.result.vipEndDate.split(' ')[0];
                                // _this.$emit('updateVipData',vipData);
                                _this.$emit('fatherModal');
                            }
                        })
                    }else if(res.code==500){
                        this.yenoMoney=!0;
                        $("#yueButton").removeAttr("disabled");   
                    }else{
                        toast(res.message)
                        $("#yueButton").removeAttr("disabled");   
                    }                                                          
                });
            },
            hbzfCodePay(){ 
                $("#redButton").attr("disabled","disabled");
                 let _this = this;
                //  this.getFindOne()
                let userInfos = Cookies.get("userInfo")?JSON.parse(Cookies.get("userInfo")):'';
                const val={
                    grade:_this.dengjiType,
                    payWay:'RedEnvelope',
                }
                preRechargeMoney(val).then(res => {
                    if(res.code==200){
                        console.log('获取的余额的值',res)
                        toast("支付成功");  
                        if(_this.routerLink == 'go'){
                            _this.$router.push({
                                path: "/walletPackage"
                            });  
                        }                       
                        userInfo().then(res=>{
                            if (res.code==200) {
                                Cookies.set("userInfo", JSON.stringify(res.result));
                                _this.setStore("userInfo", res.result);
                                // let vipData=res.result.vipEndDate.split(' ')[0];
                                // _this.$emit('updateVipData',vipData);
                                _this.$emit('fatherModal');
                            }
                        })
                    }else if(res.code==500){
                        this.hbnoMoney=!0;
                        $("#redButton").removeAttr("disabled"); 
                    }else{
                        toast(res.message)
                        $("#redButton").removeAttr("disabled"); 
                    }                                               
                });
            },
            findOne(){
                let userInfos = Cookies.get("userInfo")?JSON.parse(Cookies.get("userInfo")):''; 
                _findOne({registerId:userInfos && userInfos.id?userInfos.id:'',}).then(res => {
                    if(res.code==200){
                        this.amount= res.result.amount
                    }                                                   
                });
            },
            getFindOne(){
                let userInfos = Cookies.get("userInfo")?JSON.parse(Cookies.get("userInfo")):''; 
                _getFindOne({registerId:userInfos && userInfos.id?userInfos.id:'',}).then(res=>{
                    if(res.code ==200){
                        this.hbamount = res.result.amount
                    }
                })
            },
            //失焦事件
            inputBlur(){
                if(this.money){
                    this.wxCodePay();  
                    this.zfbCodePay();
                    this.showCode=1
                }             
            },
            //选项卡选中
            changeTabs(val){
                console.log('++++++++++++++++',val)
                clearInterval(this.clearTimer);
                this.clearTimer = undefined;
                if(val==0){
                    this.pandShow = 0;
                    this.wxCodePay();
                }else if(val==1){
                    this.pandShow = 1;
                    this.zfbCodePay();
                }else if(val==2){
                    this.pandShow = 2;
                    // this.yezfCodePay();
                }else{
                    this.pandShow = 3;
                    // this.hbzfCodePay();
                }
            },
            //查询支付状态
            getPayStatus(){
                let _this = this
                if(this.pandShow == 0){
                    this.getRequest("/registerVipMemberApplication/get/"+this.wxId).then(res => {
                        if(res.code==200){
                            if (res.result.payStatus == "paid") {
                                clearInterval(this.clearTimer);
                                toast("支付成功");
                                if(_this.routerLink == 'go'){
                                    _this.$router.push({
                                        path: "/walletPackage"
                                    });  
                                }                                 
                                userInfo().then(res=>{
                                    if (res.code==200) {
                                        Cookies.set("userInfo", JSON.stringify(res.result));
                                        _this.setStore("userInfo", res.result);
                                        // let vipData=res.result.vipEndDate.split(' ')[0];
                                        // _this.$emit('updateVipData',vipData);
                                        _this.$emit('fatherModal');
                                    }
                                })
                            }
                        }
                    });
                }
                if(this.pandShow == 1){
                    this.getRequest("/registerVipMemberApplication/get/"+this.zfbId).then(res => {
                        if(res.code==200){
                            if (res.result.payStatus == "paid") {
                                clearInterval(this.clearTimer);
                                toast("支付成功");                              
                                userInfo().then(res=>{
                                    if (res.code==200) {
                                        Cookies.set("userInfo", JSON.stringify(res.result));
                                        _this.setStore("userInfo", res.result);
                                        let vipData=res.result.vipEndDate.split(' ')[0];
                                        _this.$emit('updateVipData',vipData);
                                        _this.$emit('fatherModal');
                                    }
                                })
                            }
                        }
                    });
                }
            },
            _goPersonOrEnterVip(){
                let userInfos = Cookies.get("userInfo")?JSON.parse(Cookies.get("userInfo")):'';
                let accountScope = userInfos && userInfos.accountType?userInfos.accountType:''
                goPersonOrEnterVip({accountScope:accountScope}).then(res => {
                    if(res.code == 200){
                        this.vipList = res.result
                        let showKtList = this.vipList.slice(0,3)
                        for(let j=0;j<showKtList.length;j++){
                            switch(j){
                                case 0 :
                                    showKtList[j].url = require('../../../../assets/one_month.png')
                                    break;
                                case 1 :
                                    showKtList[j].url = require('../../../../assets/three_month.png')
                                    break;
                                case 2 :
                                    showKtList[j].url = require('../../../../assets/december_month.png')
                                    break;
                                default:
                                    break;
                            }
                        }
                        this.showKtList = showKtList
                    }
                })
            }        
        },
        watch:{
            'money':{
                handler:function(){
                    let re = /^[0-9]*$/;
                    if (re.test(Number(this.money))){
                        if (Number(this.money) < 10) {
                            this.moneyTip="充值金额不得低于10元"
                            this.showMoney = true;
                        } else {
                            this.moneyTip=""
                            this.showMoney = false;
                        }
                    }else{
                        this.moneyTip="请输入整数金额"
                        this.showMoney = true;
                    }
                }
            },
        },
        mounted(){
            // this.wxCodePay();
            this._goPersonOrEnterVip()
        }
    }
</script>

<style scoped lang="less">
    .generalframezz{
        background: rgba(0, 0, 0, 0.7);
        position: fixed;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        text-align: center;
        margin: auto;
        z-index: 558;
        .generalcontent{
            background:#fff;
            position: absolute;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            margin: auto;
            border-radius:8px;
            .general_title{
                background:rgba(255,255,255,1);
                box-shadow:0px 2px 18px 0px rgba(211,214,225,0.15);
                border-radius:8px 8px 0px 0px;
                font-size:14px;
                font-weight:400;
                color:rgba(51,51,51,1);
                display:flex;
                justify-content: space-between;
                padding:0 30px 0 20px;
                align-items: center;
                .general_title_left{
                    display:flex;
                    justify-content: flex-start;
                    align-items: center;
                }
                .timgtishi{
                    width:25px;
                    height:25px;
                    margin-right:10px;
                }
                .timgclose{
                    width:18px;
                    height:18px;
                    cursor: pointer;
                }
            }
            .recharge-from{
                height: 46px;
                margin:20px 50px 0px;
                display: flex;
                justify-content: flex-start;
                align-items: center;
                font-size:14px;
                font-weight:400;
                color:rgba(51,51,51,1);
                .text-input{
                    width:332px;
                    height:46px;
                    border:0px;
                    outline: none;
                    border-radius:4px;
                    border:1px solid rgba(222,226,230,1);
                    text-indent: 10px;
                    margin:0px 20px 0px 25px;
                }
            }
            .recharge-code{
                margin: 41px 0px 0px 58px;
                position: relative;
                /deep/ .ivu-tabs-bar{
                    border-bottom:0px;
                    margin-bottom:0px;
                    position: relative;
                }
                /deep/ .ivu-tabs.ivu-tabs-card>.ivu-tabs-bar .ivu-tabs-nav-container{
                    height: auto;
                }
                /deep/ .ivu-tabs.ivu-tabs-card>.ivu-tabs-bar .ivu-tabs-tab{
                    width:169px;
                    height:62px;
                    line-height: 62px;
                    text-indent:30px;
                    background:rgba(255,255,255,1);
                    border:1px solid rgba(233,233,233,1);
                    padding: 0px;
                    margin-right: 15px;
                    font-size:16px;
                    color:rgba(102,102,102,1);
                }
                /deep/ .ivu-tabs-nav-container:focus .ivu-tabs-tab-focused,
                /deep/ .ivu-tabs.ivu-tabs-card>.ivu-tabs-bar .ivu-tabs-tab-active{
                    box-shadow:0px 2px 40px 0px rgba(29,31,108,0.04)!important;
                    border:1px solid #121210!important;
                }
                .position-img{
                    position: absolute;
                    width:20px;
                    height: 18px;
                    z-index: 9999;                       
                }
                .card-code{
                    width:164px;
                    height: 164px;
                    margin-top:40px;
                    margin-left: -84px;
                }
                
            }
        }
    }
    .red-p{
        color: #f00;
        text-align: left;
        margin-left: 145px;
    }
    .hbyeplw{
        height:20px;
        font-size:14px;
        font-weight:400;
        color:rgba(51,51,51,1);
        line-height:20px;
        margin-top:62px;
        margin-left:-84px;
    }
    .hbyeplx{
        height:25px;
        font-size:18px;
        font-weight:bold;
        color:rgba(51,51,51,1);
        line-height:25px;
        margin-top:15px;
        margin-left:-84px;
    }
    .hbyeply{
        height:20px;
        font-size:14px;
        font-weight:400;
        color:rgba(51,51,51,1);
        line-height:20px;
        margin-top:5px;
        margin-left:-84px;
    }
    .hbyepbutton{
        width: 100px;
        height: 30px;
        line-height: 30px;
        border: 0;
        outline: none;
        background: #121210;
        font-size: 12px;
        font-weight: 400;
        color: #fff;
        cursor: pointer;
        margin-bottom: 8px;
        margin-top:20px;
        margin-left:-84px;
    }
    .topManb{
        display:flex;
        justify-content: flex-start;
        height:77px;
        line-height:77px;
    }
    .vip_cont_subpay{
        display:flex;
        justify-content: flex-start;
        align-items: center;
        width:266px;
        height:77px;
        background:rgba(255,255,255,1);
        box-shadow:0px 2px 40px 0px rgba(29,31,108,0.04);
        border-radius:4px;
        margin-left:10px;
        img{
            width:40px;
            height:40px;
            margin-left:20px;
        }
        div{
            p:first-child{
                width:90px;
                height:22px;
                font-size:16px;
                font-weight:800;
                color:rgba(51,51,51,1);
                line-height:22px;
                margin-right:23px;
            }
            p:last-child{
                height:20px;
                font-size:14px;
                font-weight:400;
                color:rgba(51,51,51,1);
                line-height:20px;
                margin-top:6px;
                margin-left:15px;
                text-align: left;
            }
        }
        input{
            width:74px;
            height:40px;
            background: #fff;
			border-radius: 21px;
			border: none;
			font-size: 14px;
			color: #181818;
			text-align: center;
			line-height: 40px;
			cursor: pointer;
			outline: none;
			float: right;
			margin-right: 20px;
			// margin-top: 35px;
			&:hover{
				background: #ffdc85;
			}
        }
    }
</style>